import { render, staticRenderFns } from "./data_chart_kependudukan.vue?vue&type=template&id=64faf047&scoped=true&"
import script from "./data_chart_kependudukan.vue?vue&type=script&lang=js&"
export * from "./data_chart_kependudukan.vue?vue&type=script&lang=js&"
import style0 from "./data_chart_kependudukan.vue?vue&type=style&index=0&id=64faf047&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64faf047",
  null
  
)

export default component.exports